document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-upsell-card__add');
  if (!btn) return;
  btn.disabled = true;
  btn.textContent = 'Lägger till...';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.dataset.variantId, quantity: 1, properties: btn.dataset.inspired ? { 'Inspirerad av': btn.dataset.inspired } : {} }] })
    });

    const res = await fetch(window.location.pathname + window.location.search);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('#CartDrawer');
    const oldDrawer = document.querySelector('#CartDrawer');
    if (newDrawer && oldDrawer) {
      oldDrawer.innerHTML = newDrawer.innerHTML;
    }

    const newBubble = doc.querySelector('#cart-icon-bubble');
    const oldBubble = document.querySelector('#cart-icon-bubble');
    if (newBubble && oldBubble) {
      oldBubble.innerHTML = newBubble.innerHTML;
    }
  } catch (err) {
    btn.disabled = false;
    btn.textContent = 'Lägg till';
  }
});